<nz-segmented
  class="ui-segmented"
  [nzOptions]="options"
  [ngModel]="value"
  (ngModelChange)="handleValueChange($event)"
  [nzBlock]="block"
></nz-segmented>
